import(/* webpackMode: "eager", webpackExports: ["GlobalReauthHandler"] */ "/app/components/auth/GlobalReauthHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgentDebugDialog"] */ "/app/components/debug/AgentDebugDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["A11yModeRuntime"] */ "/app/components/shared/A11yModeRuntime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/app/components/shell/AppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellProvider"] */ "/app/components/shell/AppShellProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrainingAchievementProvider"] */ "/app/components/training/TrainingAchievementProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgentDebugProvider"] */ "/app/contexts/AgentDebugContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProviderWrapper"] */ "/app/lib/navigation/NavigationProviderWrapper.tsx");
